import React from "react";
import PropTypes from "prop-types";
import Remarkable from "react-remarkable";
import _c from "classnames";
import styled from "styled-components";
import TrueLensLogoLight from "./img/logo-light.svg";
import TrueLensLogoDark from "./img/logo-dark.svg";

export const SectionHeader = styled.h2.attrs({
  className: p =>
    _c(
      "h2 font-light color-tt center mt4 mb2 py1 line-height-4 mmy0",
      p.className
    ),
})`
  word-break: break-word;
`;

const transform = obj => {
  let str = "";
  obj.x && (str += `translateX(${obj.x})`);
  obj.y && (str += `translateY(${obj.y})`);
  obj.scale && (str += `scale(${obj.scale})`);
  obj.scaleX && (str += `scaleX(${obj.scaleX})`);
  obj.scaleY && (str += `scaleY(${obj.scaleY})`);
  return str;
};
const appendTransform = (obj = {}, props) => {
  if (props.transform) {
    obj.transform = transform(props.transform);
  }
  return obj;
};

const appendColorBlock = (obj = {}, props) => {
  if (props.color) {
    let { x = 22, y = -22, blur = 0, color = "transparent" } = props.color;
    obj.boxShadow = `${x}px ${y}px ${blur}px ${color}`;
  }
  return obj;
};

export const ShadowWrapper = styled.div.attrs({
  className: "shadow-wrapper",
  style: p => ({}),
})`
  position: relative;
  display: inline-block;
  img.show {
    position: absolute;
  }

  @media (max-width: 900px) {
    img {
      width: calc(100% - 20px);

      &.isRight {
        transform: translateX(-20px);
      }
    }
  }
`;
export const Shadow = styled.div.attrs({
  className: "shadow",
  style: p => ({}),
})`
  position: absolute;
  top: 20px;
  left: 20px;
  right: 20px;
  bottom: 20px;
  /* box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.3); */
`;

export const Image = props => {
  if (props.shadow === true) {
    return (
      <ShadowWrapper
        style={appendTransform({}, props)}
        className={props.wrapperClassName}
      >
        <Shadow />
        <img
          className={_c("show", props.imageClassName)}
          src={props.src}
          alt={props.alt || ""}
          width={props.width}
          height={props.height}
          onClick={props.onClick}
        />
        <img
          style={appendColorBlock({}, props)}
          className={_c("back", props.imageClassName)}
          src={props.src}
          alt={props.alt || ""}
          width={props.width}
          height={props.height}
          onClick={props.onClick}
        />
      </ShadowWrapper>
    );
  } else {
    return (
      <img
        style={appendColorBlock(appendTransform({}, props), props)}
        className={_c(props.imageClassName, props.wrapperClassName)}
        src={props.src}
        alt={props.alt || ""}
        width={props.width}
        height={props.height}
        onClick={props.onClick}
      />
    );
  }
};
Image.propTypes = {
  shadow: PropTypes.bool,
  imageClassName: PropTypes.string,
  wrapperClassName: PropTypes.string,
};

export class Video extends React.Component {
  $video = React.createRef();
  componentDidMount() {
    this.changeVideoState();
  }
  componentDidUpdate() {
    this.changeVideoState();
  }
  changeVideoState() {
    if (this.$video.current) {
      if (this.props.enabled) {
        if (this.$video.current.paused) {
          this.$video.current.currentTime = 0;
          this.$video.current.play();
        }
      } else {
        if (!this.$video.current.paused) {
          this.$video.current.pause();
        }
      }
    }
  }
  render() {
    return (
      <ShadowWrapper
        style={appendTransform({}, this.props)}
        className={_c("fit slide", {
          "slide-hide": !this.props.enabled,
        })}
      >
        <video
          ref={this.$video}
          className={_c("show", this.props.imageClassName)}
          onClick={this.props.onClick}
          playsInline
          loop
          muted
          autoPlay
          style={{ height: "100%" }}
          poster={this.props.poster}
        >
          <source src={`${this.props.src}`} type="video/mp4" />
          <source
            src={`${this.props.src.replace(".mp4", ".ogg")}`}
            type="video/ogg"
          />
        </video>
      </ShadowWrapper>
    );
  }
}

export const MarkdownGenerator = (props = {}) => {
  const MarkdownOptions = { breaks: true };
  const MarkdownContainer = styled.div.attrs({ className: props.className })`
    ${props.style};
  `;
  const MarkdownInstance = props => (
    <Remarkable options={MarkdownOptions} container={MarkdownContainer}>
      {props.children}
    </Remarkable>
  );
  return props => {
    return <MarkdownInstance>{props.children}</MarkdownInstance>;
  };
};

export const Logo = ({ variation = "light", className = "my2 pl2 pml0" }) => (
  <img
    className={_c("fit logo", className)}
    src={variation === "light" ? TrueLensLogoLight : TrueLensLogoDark}
    alt=""
    height="55"
  />
);



// WEBPACK FOOTER //
// ./src/Blocks.js